import { DormantPoolGridQueryParamsType } from '@typeDefinitions/dormantPoolTypes';

import {
  getATGDormantPoolDataApi,
  getClaimedCustomersApi,
  getDormantPoolGridApi,
  getPoolSizeApi,
} from './services';
import { setDormantPoolStore } from './store';

export const getPoolSizeAction = async () => {
  const response = await getPoolSizeApi();
  if (response != null) {
    setDormantPoolStore('poolSize', response);
  }
};

export const getClaimedCustomersAction = async () => {
  const response = await getClaimedCustomersApi();
  if (response) {
    setDormantPoolStore('claimed', response);
  }
};

export const getATGDormantPoolDataAction = async () => {
  const response = await getATGDormantPoolDataApi();
  if (response) {
    setDormantPoolStore('ATGData', response);
  }
};

export const getDormantPoolGridAction = async (
  payload: DormantPoolGridQueryParamsType,
) => {
  const response = await getDormantPoolGridApi(payload);
  if (response) {
    setDormantPoolStore('gridView', 'data', response);
  } else {
    setDormantPoolStore('gridView', 'data', []);
  }
};
